import React, { useState } from 'react';
import { Play } from 'lucide-react';

// YouTube URL'den video ID'yi çıkar (Normal video ve Shorts desteği)
const getYouTubeId = (url) => {
  if (!url) return null;
  
  // YouTube Shorts formatı: youtube.com/shorts/VIDEO_ID
  const shortsRegExp = /(?:youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/;
  const shortsMatch = url.match(shortsRegExp);
  if (shortsMatch) return shortsMatch[1];
  
  // Normal YouTube formatları
  const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[7].length === 11) ? match[7] : null;
};

const YouTubeEmbed = ({ url, title, label = 'Proje Videosu', isShorts = false }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const videoId = getYouTubeId(url);

  if (!videoId) return null;

  const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;

  // Shorts için dikey (9:16), normal için yatay (16:9)
  const aspectClass = isShorts ? 'aspect-[9/16] max-w-sm mx-auto' : 'aspect-video';

  return (
    <div className={`relative ${aspectClass} rounded-lg overflow-hidden bg-anthracite-light border border-gold/10`}>
      {!isLoaded ? (
        <button
          onClick={() => setIsLoaded(true)}
          className="absolute inset-0 w-full h-full group"
        >
          <img
            src={thumbnailUrl}
            alt={title || 'Video'}
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
            }}
          />
          <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors duration-300" />
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-20 h-20 bg-gold rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
              <Play className="w-8 h-8 text-anthracite ml-1" fill="currentColor" />
            </div>
          </div>
          <div className="absolute bottom-4 left-4 flex items-center space-x-2">
            <div className="px-3 py-1 bg-gold/90 text-anthracite text-sm font-medium rounded">
              {label}
            </div>
          </div>
        </button>
      ) : (
        <iframe
          src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
          title={title || 'YouTube video'}
          className="absolute inset-0 w-full h-full"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      )}
    </div>
  );
};

export default YouTubeEmbed;
